
// // // import React, { useState, useEffect } from "react";
// // // import { useNavigate, useParams } from 'react-router-dom';
// // // import axios from "axios";

// // // const CommentBox = ({ placeholder = "Type a comment...", onCommentChange, clearComment  }) => {
// // //   const [comment, setComment] = useState("");
// // //   const [users, setUsers] = useState([]);
// // //   const [suggestions, setSuggestions] = useState([]);
// // //   const [term, setTerm] = useState('');
// // //   const [results, setResults] = useState([]);
// // //   const { tenant } = useParams();

// // //   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

// // //   // useEffect(() => {
// // //   //   axios.get(`${baseUrl}/api/${tenant}/users`)
// // //   //     .then((response) => {
// // //   //       setUsers(response.data.users || []);
// // //   //     })
// // //   //     .catch((error) => {
// // //   //       console.error("❌ Error fetching users:", error);
// // //   //       setUsers([]);
// // //   //     });
// // //   // }, [tenant]);

// // //   useEffect(() => {
// // //   const t = setTimeout(async () => {
// // //     if (!tenant || !term.trim()) return setResults([]);
// // //     try {
// // //       const { data } = await axios.get(`/api/${tenant}/users`, { params: { query: term } });
// // //       setResults(data?.users || []);
// // //     } catch (e) { console.error(e); }
// // //   }, 250); // debounce
// // //   return () => clearTimeout(t);
// // // }, [tenant, term]);
  

// // //   const handleInputChange = (e) => {
// // //     const input = e.target.value;
// // //     setComment(input);
// // //     onCommentChange(input);

// // //     if (input.includes("@")) {
// // //       const searchText = input.split("@").pop().toLowerCase();
// // //       setSuggestions(users.filter((user) => user.username.toLowerCase().includes(searchText)));
// // //     } else {
// // //       setSuggestions([]);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     if (clearComment) {
// // //       setComment(""); // ✅ Clear comment on successful task submission
// // //     }
// // //   }, [clearComment]);

// // //   // return (
// // //   //   <div className="comment-box">
// // //   //     <textarea 
// // //   //     value={comment} 
// // //   //     onChange={handleInputChange} 
// // //   //     placeholder={placeholder}
// // //   //     style={{ color: "black" }}
// // //   //     />

// // //   //     {suggestions.length > 0 && (
// // //   //       <ul className="suggestions">
// // //   //         {suggestions.map((user) => (
// // //   //           <li key={user.id} onClick={() => setComment((prev) => prev.replace(/@\S*$/, `@${user.username} `))}>
// // //   //             @{user.username}
// // //   //           </li>
// // //   //         ))}
// // //   //       </ul>
// // //   //     )}
// // //   //   </div>
// // //   // );
// // //   return (
// // //   <div className="comment-box">
// // //     <textarea 
// // //       value={comment} 
// // //       onChange={handleInputChange} 
// // //       placeholder={placeholder}
// // //       className="comment-textarea"
// // //     />

// // //     {suggestions.length > 0 && (
// // //       <ul className="suggestions">
// // //         {suggestions.map((user) => (
// // //           <li 
// // //             key={user.id} 
// // //             onClick={() =>
// // //               setComment((prev) => prev.replace(/@\S*$/, `@${user.username} `))
// // //             }
// // //           >
// // //             @{user.username}
// // //           </li>
// // //         ))}
// // //       </ul>
// // //     )}
// // //   </div>
// // // );
// // // };

// // // export default CommentBox;


// // // client/src/components/CommentBox.jsx
// // import React, { useState, useEffect, useRef } from "react";
// // import { useParams } from 'react-router-dom';
// // import axios from "axios";
// // import './CommentBox.css';

// // const CommentBox = ({ 
// //   placeholder = "Type a comment...", 
// //   onCommentChange, 
// //   clearComment,
// //   value: controlledValue 
// // }) => {
// //   const [comment, setComment] = useState(controlledValue || "");
// //   const [users, setUsers] = useState([]);
// //   const [suggestions, setSuggestions] = useState([]);
// //   const [mentionQuery, setMentionQuery] = useState('');
// //   const [showSuggestions, setShowSuggestions] = useState(false);
// //   const [selectedIndex, setSelectedIndex] = useState(0);
// //   const [cursorPosition, setCursorPosition] = useState(0);
  
// //   const textareaRef = useRef(null);
// //   const suggestionsRef = useRef(null);
  
// //   const { tenant } = useParams();
// //   const baseUrl = process.env.REACT_APP_BASE_URL || '';

// //   /**
// //    * Load users when tenant changes
// //    */
// //   useEffect(() => {
// //     if (!tenant) return;

// //     const loadUsers = async () => {
// //       try {
// //         const { data } = await axios.get(`${baseUrl}/api/${tenant}/users`, {
// //           withCredentials: true
// //         });
// //         setUsers(data?.users || []);
// //       } catch (error) {
// //         console.error("❌ Error fetching users:", error);
// //         setUsers([]);
// //       }
// //     };

// //     loadUsers();
// //   }, [tenant, baseUrl]);

// //   /**
// //    * Handle controlled value changes
// //    */
// //   useEffect(() => {
// //     if (controlledValue !== undefined && controlledValue !== comment) {
// //       setComment(controlledValue);
// //     }
// //   }, [controlledValue]);

// //   /**
// //    * Clear comment when requested
// //    */
// //   useEffect(() => {
// //     if (clearComment) {
// //       setComment("");
// //       setSuggestions([]);
// //       setShowSuggestions(false);
// //       setMentionQuery('');
// //     }
// //   }, [clearComment]);

// //   /**
// //    * Handle input changes
// //    */
// //   const handleInputChange = (e) => {
// //     const input = e.target.value;
// //     const cursor = e.target.selectionStart;
    
// //     setComment(input);
// //     setCursorPosition(cursor);
    
// //     // Notify parent
// //     if (onCommentChange) {
// //       onCommentChange(input);
// //     }

// //     // Check for @ mentions
// //     const textBeforeCursor = input.slice(0, cursor);
// //     const lastAtIndex = textBeforeCursor.lastIndexOf("@");

// //     if (lastAtIndex !== -1) {
// //       const textAfterAt = textBeforeCursor.slice(lastAtIndex + 1);
      
// //       // Check if we're still in a mention (no spaces after @)
// //       if (!textAfterAt.includes(" ")) {
// //         const query = textAfterAt.toLowerCase();
// //         setMentionQuery(query);
        
// //         // Filter users
// //         const filtered = users.filter((user) => 
// //           user.username.toLowerCase().includes(query)
// //         );
        
// //         setSuggestions(filtered.slice(0, 10)); // Limit to 10 suggestions
// //         setShowSuggestions(filtered.length > 0);
// //         setSelectedIndex(0);
// //         return;
// //       }
// //     }

// //     // Hide suggestions if not in a mention
// //     setShowSuggestions(false);
// //     setSuggestions([]);
// //     setMentionQuery('');
// //   };

// //   /**
// //    * Handle suggestion selection
// //    */
// //   const selectSuggestion = (username) => {
// //     if (!username) return;

// //     const textBeforeCursor = comment.slice(0, cursorPosition);
// //     const textAfterCursor = comment.slice(cursorPosition);
// //     const lastAtIndex = textBeforeCursor.lastIndexOf("@");

// //     if (lastAtIndex !== -1) {
// //       const newText = 
// //         comment.slice(0, lastAtIndex) + 
// //         `@${username} ` + 
// //         textAfterCursor;
      
// //       setComment(newText);
      
// //       // Notify parent
// //       if (onCommentChange) {
// //         onCommentChange(newText);
// //       }

// //       // Hide suggestions
// //       setShowSuggestions(false);
// //       setSuggestions([]);
// //       setMentionQuery('');

// //       // Focus back on textarea and set cursor position
// //       setTimeout(() => {
// //         if (textareaRef.current) {
// //           const newCursor = lastAtIndex + username.length + 2; // +2 for @ and space
// //           textareaRef.current.focus();
// //           textareaRef.current.setSelectionRange(newCursor, newCursor);
// //         }
// //       }, 0);
// //     }
// //   };

// //   /**
// //    * Handle keyboard navigation in suggestions
// //    */
// //   const handleKeyDown = (e) => {
// //     if (!showSuggestions || suggestions.length === 0) return;

// //     switch (e.key) {
// //       case 'ArrowDown':
// //         e.preventDefault();
// //         setSelectedIndex((prev) => 
// //           prev < suggestions.length - 1 ? prev + 1 : prev
// //         );
// //         break;
      
// //       case 'ArrowUp':
// //         e.preventDefault();
// //         setSelectedIndex((prev) => (prev > 0 ? prev - 1 : 0));
// //         break;
      
// //       case 'Enter':
// //         if (showSuggestions) {
// //           e.preventDefault();
// //           if (suggestions[selectedIndex]) {
// //             selectSuggestion(suggestions[selectedIndex].username);
// //           }
// //         }
// //         break;
      
// //       case 'Escape':
// //         e.preventDefault();
// //         setShowSuggestions(false);
// //         setSuggestions([]);
// //         break;
      
// //       default:
// //         break;
// //     }
// //   };

// //   /**
// //    * Scroll selected suggestion into view
// //    */
// //   useEffect(() => {
// //     if (showSuggestions && suggestionsRef.current) {
// //       const selectedElement = suggestionsRef.current.children[selectedIndex];
// //       if (selectedElement) {
// //         selectedElement.scrollIntoView({
// //           block: 'nearest',
// //           behavior: 'smooth'
// //         });
// //       }
// //     }
// //   }, [selectedIndex, showSuggestions]);

// //   return (
// //     <div className="comment-box-wrapper">
// //       <textarea
// //         ref={textareaRef}
// //         value={comment}
// //         onChange={handleInputChange}
// //         onKeyDown={handleKeyDown}
// //         placeholder={placeholder}
// //         className="comment-textarea form-control"
// //         rows={4}
// //         style={{ color: "black", resize: "vertical" }}
// //       />

// //       {showSuggestions && suggestions.length > 0 && (
// //         <ul ref={suggestionsRef} className="mention-suggestions">
// //           {suggestions.map((user, index) => (
// //             <li
// //               key={user.id}
// //               className={`suggestion-item ${index === selectedIndex ? 'selected' : ''}`}
// //               onClick={() => selectSuggestion(user.username)}
// //               onMouseEnter={() => setSelectedIndex(index)}
// //             >
// //               <div className="suggestion-content">
// //                 <div className="suggestion-username">@{user.username}</div>
// //                 {user.email && (
// //                   <div className="suggestion-email">{user.email}</div>
// //                 )}
// //               </div>
// //             </li>
// //           ))}
// //         </ul>
// //       )}

// //       {mentionQuery && showSuggestions && suggestions.length === 0 && (
// //         <div className="no-suggestions">
// //           No users found matching "@{mentionQuery}"
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default CommentBox;


// // client/src/components/CommentBox.jsx
// import React, { useState, useEffect, useRef } from "react";
// import { useParams } from 'react-router-dom';
// import axios from "axios";
// import './CommentBox.css';

// const CommentBox = ({ 
//   placeholder = "Type a comment...", 
//   onCommentChange, 
//   clearComment,
//   value: controlledValue 
// }) => {
//   const [comment, setComment] = useState(controlledValue || "");
//   const [users, setUsers] = useState([]);
//   const [suggestions, setSuggestions] = useState([]);
//   const [mentionQuery, setMentionQuery] = useState('');
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [selectedIndex, setSelectedIndex] = useState(0);
//   const [cursorPosition, setCursorPosition] = useState(0);
  
//   const textareaRef = useRef(null);
//   const suggestionsRef = useRef(null);
  
//   const { tenant } = useParams();
//   const baseUrl = process.env.REACT_APP_BASE_URL || '';

//   /**
//    * Load users when tenant changes
//    */
//   useEffect(() => {
//     if (!tenant) return;

//     const loadUsers = async () => {
//       try {
//         const { data } = await axios.get(`${baseUrl}/api/${tenant}/users`, {
//           withCredentials: true
//         });
//         setUsers(data?.users || []);
//       } catch (error) {
//         console.error("❌ Error fetching users:", error);
//         setUsers([]);
//       }
//     };

//     loadUsers();
//   }, [tenant, baseUrl]);

//   /**
//    * Handle controlled value changes
//    */
//   useEffect(() => {
//     if (controlledValue !== undefined && controlledValue !== comment) {
//       setComment(controlledValue);
//     }
//   }, [controlledValue]);

//   /**
//    * Clear comment when requested
//    */
//   useEffect(() => {
//     if (clearComment) {
//       setComment("");
//       setSuggestions([]);
//       setShowSuggestions(false);
//       setMentionQuery('');
//     }
//   }, [clearComment]);

//   /**
//    * Handle input changes
//    */
//   const handleInputChange = (e) => {
//     const input = e.target.value;
//     const cursor = e.target.selectionStart;
    
//     setComment(input);
//     setCursorPosition(cursor);
    
//     // Notify parent
//     if (onCommentChange) {
//       onCommentChange(input);
//     }

//     // Check for @ mentions
//     const textBeforeCursor = input.slice(0, cursor);
//     const lastAtIndex = textBeforeCursor.lastIndexOf("@");

//     if (lastAtIndex !== -1) {
//       const textAfterAt = textBeforeCursor.slice(lastAtIndex + 1);
      
//       // Check if we're still in a mention (no spaces after @)
//       if (!textAfterAt.includes(" ")) {
//         const query = textAfterAt.toLowerCase();
//         setMentionQuery(query);
        
//         // Filter users
//         const filtered = users.filter((user) => 
//           user.username.toLowerCase().includes(query)
//         );
        
//         setSuggestions(filtered.slice(0, 10)); // Limit to 10 suggestions
//         setShowSuggestions(filtered.length > 0);
//         setSelectedIndex(0);
//         return;
//       }
//     }

//     // Hide suggestions if not in a mention
//     setShowSuggestions(false);
//     setSuggestions([]);
//     setMentionQuery('');
//   };

//   /**
//    * Handle suggestion selection
//    */
//   const selectSuggestion = (username) => {
//     if (!username) return;

//     const textBeforeCursor = comment.slice(0, cursorPosition);
//     const textAfterCursor = comment.slice(cursorPosition);
//     const lastAtIndex = textBeforeCursor.lastIndexOf("@");

//     if (lastAtIndex !== -1) {
//       const newText = 
//         comment.slice(0, lastAtIndex) + 
//         `@${username} ` + 
//         textAfterCursor;
      
//       setComment(newText);
      
//       // Notify parent
//       if (onCommentChange) {
//         onCommentChange(newText);
//       }

//       // Hide suggestions
//       setShowSuggestions(false);
//       setSuggestions([]);
//       setMentionQuery('');

//       // Focus back on textarea and set cursor position
//       setTimeout(() => {
//         if (textareaRef.current) {
//           const newCursor = lastAtIndex + username.length + 2; // +2 for @ and space
//           textareaRef.current.focus();
//           textareaRef.current.setSelectionRange(newCursor, newCursor);
//         }
//       }, 0);
//     }
//   };

//   /**
//    * Handle keyboard navigation in suggestions
//    */
//   const handleKeyDown = (e) => {
//     if (!showSuggestions || suggestions.length === 0) return;

//     switch (e.key) {
//       case 'ArrowDown':
//         e.preventDefault();
//         setSelectedIndex((prev) => 
//           prev < suggestions.length - 1 ? prev + 1 : prev
//         );
//         break;
      
//       case 'ArrowUp':
//         e.preventDefault();
//         setSelectedIndex((prev) => (prev > 0 ? prev - 1 : 0));
//         break;
      
//       case 'Enter':
//         if (showSuggestions) {
//           e.preventDefault();
//           if (suggestions[selectedIndex]) {
//             selectSuggestion(suggestions[selectedIndex].username);
//           }
//         }
//         break;
      
//       case 'Escape':
//         e.preventDefault();
//         setShowSuggestions(false);
//         setSuggestions([]);
//         break;
      
//       default:
//         break;
//     }
//   };

//   /**
//    * Scroll selected suggestion into view
//    */
//   useEffect(() => {
//     if (showSuggestions && suggestionsRef.current) {
//       const selectedElement = suggestionsRef.current.children[selectedIndex];
//       if (selectedElement) {
//         selectedElement.scrollIntoView({
//           block: 'nearest',
//           behavior: 'smooth'
//         });
//       }
//     }
//   }, [selectedIndex, showSuggestions]);

//   return (
//     <div className="comment-box-wrapper">
//       <textarea
//         ref={textareaRef}
//         value={comment}
//         onChange={handleInputChange}
//         onKeyDown={handleKeyDown}
//         placeholder={placeholder}
//         className="comment-textarea form-control"
//         rows={4}
//         style={{ color: "black", resize: "vertical" }}
//       />

//       {showSuggestions && suggestions.length > 0 && (
//         <ul ref={suggestionsRef} className="mention-suggestions">
//           {suggestions.map((user, index) => (
//             <li
//               key={user.id}
//               className={`suggestion-item ${index === selectedIndex ? 'selected' : ''}`}
//               onClick={() => selectSuggestion(user.username)}
//               onMouseEnter={() => setSelectedIndex(index)}
//             >
//               <div className="suggestion-content">
//                 <div className="suggestion-username">@{user.username}</div>
//                 {user.email && (
//                   <div className="suggestion-email">{user.email}</div>
//                 )}
//               </div>
//             </li>
//           ))}
//         </ul>
//       )}

//       {mentionQuery && showSuggestions && suggestions.length === 0 && (
//         <div className="no-suggestions">
//           No users found matching "@{mentionQuery}"
//         </div>
//       )}
//     </div>
//   );
// };

// export default CommentBox;

// client/src/components/CommentBox.jsx
import React, { useState, useRef, useEffect } from 'react';
import { searchUsers } from '../../services/messagesApi';
import { getSessionLocal } from '../../services/sessionLocal';
import './CommentBox.css';

/**
 * CommentBox with @mention support
 * When user types @, shows autocomplete dropdown with users from tenant
 */
export default function CommentBox({ 
  value = '', 
  onChange, 
  placeholder = 'Add a comment...', 
  onSubmit,
  rows = 4 
}) {
  const [mentionQuery, setMentionQuery] = useState('');
  const [mentionResults, setMentionResults] = useState([]);
  const [showMentions, setShowMentions] = useState(false);
  const [mentionStartPos, setMentionStartPos] = useState(-1);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const textareaRef = useRef(null);
  const mentionListRef = useRef(null);

  // Get tenant from session
  const session = getSessionLocal();
  const tenantId = session?.tenantId || session?.tenantid;

  // Detect @ mentions
  useEffect(() => {
    if (!value) {
      setShowMentions(false);
      return;
    }

    const cursorPos = textareaRef.current?.selectionStart || value.length;
    const textBeforeCursor = value.substring(0, cursorPos);
    
    // Find last @ before cursor
    const lastAtIndex = textBeforeCursor.lastIndexOf('@');
    
    if (lastAtIndex === -1) {
      setShowMentions(false);
      return;
    }

    // Check if there's a space after the @ (which ends the mention)
    const textAfterAt = textBeforeCursor.substring(lastAtIndex + 1);
    if (textAfterAt.includes(' ') || textAfterAt.includes('\n')) {
      setShowMentions(false);
      return;
    }

    // Extract query after @
    const query = textAfterAt.trim();
    setMentionQuery(query);
    setMentionStartPos(lastAtIndex);
    setShowMentions(true);
    setSelectedIndex(0);

    // Search for users if query is not empty
    if (query.length > 0) {
      searchUsersDebounced(query);
    } else {
      setMentionResults([]);
    }
  }, [value, tenantId]);

  // Debounced user search
  const searchUsersDebounced = useRef(
    debounce(async (query) => {
      if (!tenantId || query.length < 1) {
        setMentionResults([]);
        return;
      }

      try {
        const result = await searchUsers(query, { tenantId });
        const users = result?.users || [];
        setMentionResults(users.slice(0, 10)); // Limit to 10 results
      } catch (error) {
        console.error('User search failed:', error);
        setMentionResults([]);
      }
    }, 300)
  ).current;

  // Handle mention selection
  const selectMention = (user) => {
    if (!textareaRef.current || mentionStartPos === -1) return;

    const username = user?.username || user?.displayName || user?.email || 'Unknown';
    const beforeMention = value.substring(0, mentionStartPos);
    const afterMention = value.substring(textareaRef.current.selectionStart);
    
    const newValue = beforeMention + `@${username} ` + afterMention;
    onChange({ target: { value: newValue } });

    // Reset mention state
    setShowMentions(false);
    setMentionQuery('');
    setMentionResults([]);
    setMentionStartPos(-1);

    // Focus back on textarea
    setTimeout(() => {
      textareaRef.current?.focus();
      const newCursorPos = beforeMention.length + username.length + 2;
      textareaRef.current?.setSelectionRange(newCursorPos, newCursorPos);
    }, 0);
  };

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (!showMentions || mentionResults.length === 0) {
      // Allow form submission on Enter if not showing mentions
      if (e.key === 'Enter' && !e.shiftKey && onSubmit) {
        e.preventDefault();
        onSubmit();
      }
      return;
    }

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setSelectedIndex(prev => 
          prev < mentionResults.length - 1 ? prev + 1 : 0
        );
        break;
      
      case 'ArrowUp':
        e.preventDefault();
        setSelectedIndex(prev => 
          prev > 0 ? prev - 1 : mentionResults.length - 1
        );
        break;
      
      case 'Enter':
        if (showMentions && mentionResults[selectedIndex]) {
          e.preventDefault();
          selectMention(mentionResults[selectedIndex]);
        }
        break;
      
      case 'Escape':
        e.preventDefault();
        setShowMentions(false);
        setMentionResults([]);
        break;
      
      default:
        break;
    }
  };

  // Scroll selected item into view
  useEffect(() => {
    if (mentionListRef.current && showMentions) {
      const selectedItem = mentionListRef.current.children[selectedIndex];
      if (selectedItem) {
        selectedItem.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
  }, [selectedIndex, showMentions]);

  return (
    <div className="comment-box-wrapper">
      <textarea
        ref={textareaRef}
        className="comment-textarea form-control"
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        rows={rows}
      />
      
      {showMentions && mentionResults.length > 0 && (
        <div className="mention-suggestions" ref={mentionListRef}>
          {mentionResults.map((user, index) => {
            const username = user?.username || user?.displayName || 'Unknown';
            const email = user?.email || '';
            
            return (
              <div
                key={user?.id || index}
                className={`suggestion-item ${index === selectedIndex ? 'selected' : ''}`}
                onClick={() => selectMention(user)}
                onMouseEnter={() => setSelectedIndex(index)}
              >
                <div className="suggestion-username">{username}</div>
                {email && <div className="suggestion-email">{email}</div>}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// Simple debounce function
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}